<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  attribution: {
    type: Object,
    default: null
  }
})

const show = computed(() => {
  return props.attribution && props.attribution.show
})
</script>

<template>
  <div v-if="show" class="attribution-overlay">
    <span class="attribution-text">
      Photo by
      <a :href="attribution.photographer_url" target="_blank" rel="noopener noreferrer">
        {{ attribution.photographer }}
      </a>
      on
      <a :href="attribution.logo_url || 'https://unsplash.com/?utm_source=zoom_out_game&utm_medium=referral'"
        target="_blank" rel="noopener noreferrer">
        Unsplash
      </a>
    </span>
  </div>
</template>

<style scoped>
.attribution-overlay {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 4px 8px;
  border-radius: 4px;
  z-index: 100;
  /* 画像の上に表示されるように */
  pointer-events: auto;
  /* クリック可能に */
}

.attribution-text {
  color: #ffffff;
  font-size: 0.8rem;
  font-family: sans-serif;
}

.attribution-text a {
  color: #ffffff;
  text-decoration: underline;
}

.attribution-text a:hover {
  color: #cccccc;
}
</style>
